import { IonSegment, IonSegmentButton, IonLabel,IonText,IonCol,IonRow } from "@ionic/react";
import useAuth from "hooks/useAuth";
import { useState, ReactNode, useEffect, memo } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import ChallengesList from "./ChallengesList";
import PageTitle from "./PageTitle";
import styled from 'styled-components';



interface ChallengeTabsProps extends RouteComponentProps {
	pending: Challenge[]	
	pendingtournament: Tournament[]	
	pendingevent:Event[]
	upcoming: Challenge[]	
	upcomingtournament: Tournament[]
	upcomingevent: Event[]	
	past: Challenge[]
	pasttournament: Tournament[]
	pastevent: Event[]
	user_id?: string
	refreshChallenges: () => void
	onChallengeTypeChange?: (type: ChallengeListType) => void 
	pastcount?: string
}



interface ChallengeListProps {title: string, challenges: Challenge[],tournament: Tournament[],event: Event[]}

const ChallengesTabs: React.FC<ChallengeTabsProps> = memo((props) => {
  //console.log("Challenge tabs props count",props.pastcount);
	const {userID} = useAuth();
	const [challengeListType, setChallengeListType] = useState<ChallengeListType>('upcoming');
	const [challengeList, setChallengeList] = useState<ReactNode>();
	const [challengeListRef, setChallengeListRef] = useState<ReactNode>();

	const user_id = props.user_id ?? userID

	const getChallengeList = ({title, challenges,tournament,event}: ChallengeListProps): ReactNode => {
		if (!user_id) return null;
		return <ChallengesList 
			title={title} 
			challenges={challenges}	
			tournament={tournament}
			event={event}
			contextual_user_id={user_id}
			refreshChallenges={props.refreshChallenges}
		/>
	}

	useEffect(() => {
		let payload: ChallengeListProps = {title: "", challenges: [],tournament: [],event: []};
		if (challengeListType === 'pending'){
			//console.log("type", challengeListType);
			payload.title = "Pending";
			payload.challenges = props.pending;
			payload.tournament = props.pendingtournament;
			payload.event = props.pendingevent;
		} else if (challengeListType === 'upcoming'){
			//console.log("upcoming", challengeListType);
			payload.title = "Upcoming";
			payload.challenges = props.upcoming;
			payload.tournament = props.upcomingtournament;
			payload.event = props.upcomingevent;
		} else if (challengeListType === 'past') {
			payload.title = "Past";
			payload.challenges = props.past;
			payload.tournament = props.pasttournament;
			payload.event = props.pastevent;
		}
		let newNodes = getChallengeList(payload);
		if (JSON.stringify(newNodes) !== JSON.stringify(challengeListRef)){
			setChallengeList(newNodes);
			setChallengeListRef(newNodes);
		}
	}, [challengeListType, props.pending])


	//console.log("upcoming notification", props.upcoming.length+props.upcomingtournament.length+props.upcomingevent.length);
    //console.log("Past notification", props.pastcount);
   
	
	return (
		<div>
			<div style={{ margin: "0 var(--horizontal-gutter)" }}>
				<IonSegment
					onIonChange={e => {
						const nextChallengeType = e.detail.value as ChallengeListType;
						setChallengeListType(nextChallengeType);
						if (props.onChallengeTypeChange){
							props.onChallengeTypeChange(nextChallengeType);
						}
					}}
					value={challengeListType}
					mode="ios"
				>
					<IonSegmentButton value="upcoming" style={{height: "45px"}}>
					<IonRow style={{width: "100%"}}>
						<IonCol size="10" >
						<IonLabel>Upcoming</IonLabel>
						</IonCol>
						<IonCol size="2"><IonText style={{textAlign: "right", background: "red", margin:"-8px 0 0 0px", right: "-12px", position: "absolute", height: "24px", top: "-7px", width: "24px !important", padding: "3px 8px", borderRadius: "30px",
    color: "#fff"}}>{props.upcoming.length + props.upcomingtournament.length}</IonText></IonCol>
						</IonRow>
					</IonSegmentButton>
					<IonSegmentButton value="pending" style={{height: "45px"}}>
					<IonRow style={{width: "100%"}}>
					<IonCol size="10" >
						<IonLabel>Pending</IonLabel>
						</IonCol>
					  <IonCol size="2"><IonText style={{textAlign: "right", background: "red", margin:"-8px 0 0 0px", right: "-12px", position: "absolute", height: "24px", top: "-7px", width: "24px !important", padding: "3px 8px", borderRadius: "30px",
    color: "#fff"}}>{props.pending.length+props.pendingtournament.length}</IonText></IonCol>
						</IonRow>
					</IonSegmentButton>
					<IonSegmentButton value="past" style={{height: "45px"}}>
					<IonRow style={{width: "100%"}}>
					<IonCol size="10" >
						<IonLabel>Past</IonLabel>
						</IonCol>
					<IonCol size="2"><IonText style={{textAlign: "right", background: "red", margin:"-8px 0 0 0px", right: "-12px", position: "absolute", height: "24px", top: "-7px", width: "24px !important", padding: "3px 8px", borderRadius: "30px",
    color: "#fff"}}>{props.pastcount}</IonText></IonCol>
						</IonRow>
					</IonSegmentButton>
				</IonSegment>
			</div>
			{ challengeList }
		</div>
	)
});

export default withRouter(ChallengesTabs);
